import {
    useMemo,
} from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import getReadingThresholdType, {
    ReadingThresholdType,
} from 'app/utils/getReadingThresholdType'
import useStyles from './Temperature.styles'

const propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    lastMeasuredOnUtc: PropTypes.number.isRequired,
}

const defaultProps = {
    value: null,
}

const Temperature = (props) => {
    const {
        value,
        lastMeasuredOnUtc,
    } = props

    const {
        classes,
    } = useStyles()

    const className = useMemo(() => {
        const reading = getReadingThresholdType(lastMeasuredOnUtc)

        return clsx({
            [classes.oldReading]: reading === ReadingThresholdType.OLD,
            [classes.recentReading]: reading === ReadingThresholdType.RECENT,
            [classes.liveReading]: reading === ReadingThresholdType.LIVE,
        })
    }, [
        lastMeasuredOnUtc,
        classes,
    ])

    return (
        <div className={className}>
            {value}
        </div>
    )
}

Temperature.propTypes = propTypes
Temperature.defaultProps = defaultProps

export default Temperature
